import { LocaleLanguageCode, Languages } from 'Constants/Common';
import { ApiHelper } from './apiHelper';

export class TitleApi {
    async getTitlesAsync(
        token: string,
        successCallback: (titles: string[]) => void,
        failureCallback: (error: string) => void,
        signal: AbortSignal,
        language: string
    ): Promise<void> {
        let url = '/api/title/title?language=';

        switch (language) {
            case Languages.De:
                url += LocaleLanguageCode.DE;
                break;
            case Languages.At:
                url += LocaleLanguageCode.AT;
                break;
            case Languages.Es:
                url += LocaleLanguageCode.ES;
                break;
            default:
                url += LocaleLanguageCode.GB;
        }

        await new ApiHelper().getDataSecureAsync(
            url,
            token,
            successCallback,
            failureCallback,
            signal
        );
    }
}
